import { defineStore } from "pinia";
import * as YachtService from "@/services/yacht.service";
import {computed, ref} from "vue";
import {useSearchStore} from "@/stores/searchStore";
import {useRouter} from "vue-router";


export const useYachtStore = defineStore('yachts', () => {

    const router = useRouter();
    const selectedYachtSlug = ref('')
    const selectedYacht = ref(null)
    const loading = ref(false)
    const error = ref<string | null>(null)
    const searchStore = useSearchStore();



    const fetchYachtDetails = async (slug: string) => {
        selectedYachtSlug.value = slug
        loading.value = true
        error.value = null

        try {

            const response = await YachtService.getYachtBySlug(slug);

            if (!response) {
                console.error("Yacht not found");
                selectedYacht.value = [];
                return null;
            }
            selectedYacht.value = response.data;
            // yachts.value = response;
            console.log("Yachts loaded in store:", selectedYacht.value);
            // await searchStore.getAllYachts();
            // const yacht = searchStore.yachts.find((y) => y.slug === slug)

            if (!selectedYacht) throw new Error('Yacht not found')

            // selectedYacht.value = yacht
        } catch (err: any) {
            error.value = err?.message || 'Error fetching yacht'
        } finally {
            loading.value = false
        }

    }



    const viewYachtDetails = async (slug: string) => {
        await fetchYachtDetails(slug)
        router.push({ path: `/yachts/${slug}` })
    }

    const relatedYachts = computed(() => {
        if (!selectedYacht.value) return [];
        const selectedCategory = selectedYacht.value.category?.toLowerCase().trim();

        return searchStore.yachts.filter(
            (y) =>
                y.category?.toLowerCase().trim() === selectedCategory &&
                y.slug !== selectedYacht.value.slug
        );
    });

    // const relatedYachts = computed(() => {
    //     if (!selectedYacht.value) return [];
    //
    //     const selectedCategory = selectedYacht.value.category?.toLowerCase().trim();
    //
    //     return searchStore.yachts.filter(y => {
    //         const yachtCategory = y.category?.toLowerCase().trim();
    //         const slugCheck = y.slug !== selectedYacht.value.slug;
    //
    //         return yachtCategory === selectedCategory && slugCheck;
    //     });
    // });



    return {
        selectedYachtSlug,
        selectedYacht,
        loading,
        error,
        fetchYachtDetails,
        viewYachtDetails,
        relatedYachts
    }

});

